export default __webpack_public_path__ + "static/media/green.afd57cce.png";